import React from 'react';
import { Box } from '@mui/material';

import { ProductGroupSelectEnhancedContainer as ProductGroupSelect } from './ProductGroupSelectEnhanced/ProductGroupSelectEnhancedContainer';

import { ButtonGroup } from '../../ButtonGroup';
import { State } from '../redux';

type ComponentState = State['emConfiguration']['perTaggedItemPurchased'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  editMode: boolean;
  fieldDisabled: (field: Fields) => boolean;
};

const PerTaggedItemPurchasedConfiguration: React.FC<Props> = (props) => {
  const { countPer, editMode, fieldDisabled, summationMode, tags } = props;

  return (
    <Box>
      <Box my={4}>
        <ButtonGroup
          label='Summation Mode'
          name='summationMode'
          readonly={fieldDisabled('summationMode')}
          selectedValue={summationMode}
        >
          <ButtonGroup.Option value='include'>Include</ButtonGroup.Option>
          <ButtonGroup.Option value='exclude'>Exclude</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <ButtonGroup
          label='Count Product By'
          name='countPer'
          readonly={fieldDisabled('countPer')}
          selectedValue={countPer}
        >
          <ButtonGroup.Option value='quantity'>Quantity</ButtonGroup.Option>
          <ButtonGroup.Option value='money_amount'>Money Amount</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <ProductGroupSelect
          editMode={editMode}
          onChange={() => {}}
          readonly={fieldDisabled('tags')}
          selectedProductGroups={tags}
        />
      </Box>
    </Box>
  );
};

export { PerTaggedItemPurchasedConfiguration };
